import { useLayoutEffect } from "react";
import { errorMessage } from "utils/errorMessage";

const getQueryParamValue = (query, param) =>
  query
    .split("&")
    ?.find((a) => a.includes(param))
    ?.split("=")[1];

const RetornoPagamento = () => {
  useLayoutEffect(() => {
    const queryData = window.location.search;
    const sucesso = getQueryParamValue(queryData, "status") === "SUCESSO";
    const descricaoRetorno = decodeURIComponent(
      getQueryParamValue(queryData, "mensagem")
    );
    const codigo = descricaoRetorno?.split("Mensagem:")?.[0];

    window.parent.postMessage(
      {
        sucesso,
        descricaoRetorno: errorMessage(codigo?.split("Código:")?.[1]?.trim()),
        type: "retorno-pagamento",
      },
      window.location.origin
    );
  }, []);

  return null;
};

export default RetornoPagamento;
